export default {
  ViewReport: 'Xem Báo cáo',
  Cancel: 'Hủy',
  Year: 'Năm',
  Department: 'Phòng ban',
  InvenType: 'Loại TSCĐ',
  ShowInvenTypeWithReport: 'Hiển thị mỗi loại tài sản là một báo cáo',
  TSCDDList: 'Danh sách TSCĐ',
  ReportType: 'Mẫu báo cáo',
  TSCĐType: 'Loại tài sản cố định: Load lên tên loại tài sản cố định tương ứng với báo cáo',
  All: '<<Tất cả>>',
  MessagePrint: {
    Title: 'Không hợp lệ',
    MessageError: 'Bạn cần chọn ít nhất một Tài sản cố định.',
  },
};
